module.exports = __webpack_public_path__ + "static/img/clothing_08.483aef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_08.png
// module id = wFkX
// module chunks = 0